import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

const hotArticles = articles.slice(0, 4);
const latestArticles = articles.slice(0, 6);
const verifiedCount = articles.filter((a) => a.verified).length;

export default function Home() {
  const schemaData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '黑料不打',
        url: 'https://heilao-buda.com',
        description: '专注收录真实用户评价与行业口碑的聚合平台',
        email: 'contact@heilao-buda.com',
        address: {
          '@type': 'PostalAddress',
          addressLocality: '北京',
          addressCountry: 'CN',
        },
      },
      {
        '@type': 'WebSite',
        name: '黑料不打',
        url: 'https://heilao-buda.com',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://heilao-buda.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '黑料不打——真实口碑聚合平台',
        description: '专注收录真实用户评价与行业口碑的聚合平台，拒绝虚假黑料与恶意攻击，只呈现经过核实的客观信息。',
        url: 'https://heilao-buda.com',
        isPartOf: { '@type': 'WebSite', name: '黑料不打', url: 'https://heilao-buda.com' },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <Navbar />

      <main>
        <section className="relative w-full h-[480px] md:h-[620px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20background%20with%20deep%20crimson%20red%20and%20charcoal%20black%20gradient%2C%20subtle%20geometric%20patterns%2C%20mysterious%20atmosphere%2C%20modern%20editorial%20style%2C%20low%20key%20lighting%2C%20textured%20surface%2C%20no%20text%20no%20letters&width=1600&height=900&seq=hero-main-bg&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
          <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
              真相，不该被埋没
            </h1>
            <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
              黑料不打——专注收录真实用户评价与行业口碑的聚合平台。
              拒绝虚假黑料与恶意攻击，只呈现经过核实的客观信息。
              帮助您快速识别品牌真实口碑，做出明智消费决策。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/category/tech"
                className="inline-flex items-center px-6 py-3 bg-primary-500 text-white font-medium rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                开始浏览
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center px-6 py-3 border border-white/30 text-white font-medium rounded-md hover:bg-white/10 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>

        <section className="py-6 md:py-8 bg-background-50 border-b border-background-200/60">
          <div className="w-full px-4 md:px-6">
            <div className="flex items-center justify-center gap-8 md:gap-12 flex-wrap">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-primary-600">{articles.length}+</p>
                <p className="text-xs text-foreground-500 mt-1">深度调查</p>
              </div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-primary-600">{verifiedCount}+</p>
                <p className="text-xs text-foreground-500 mt-1">核实报道</p>
              </div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-primary-600">{categories.length}</p>
                <p className="text-xs text-foreground-500 mt-1">行业分类</p>
              </div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-accent-600">1000万+</p>
                <p className="text-xs text-foreground-500 mt-1">月度读者</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                按行业分类浏览
              </h2>
              <p className="text-sm text-foreground-500 mt-2">选择您关注的行业，查看真实口碑</p>
            </div>
            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3 md:gap-4 max-w-5xl mx-auto">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex flex-col items-center gap-2 p-4 md:p-5 bg-background-100 rounded-lg hover:bg-primary-50 transition-colors duration-200 cursor-pointer group"
                >
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-200">
                    <i className={`${cat.icon} text-lg md:text-xl`}></i>
                  </div>
                  <span className="text-xs md:text-sm font-medium text-foreground-700 whitespace-nowrap">
                    {cat.name}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                  热门调查
                </h2>
                <p className="text-sm text-foreground-500 mt-1">深度核实，还原真相</p>
              </div>
              <Link
                to="/category/tech"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer flex items-center gap-1"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {hotArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="bg-background-50 rounded-lg overflow-hidden cursor-pointer group hover:bg-background-100 transition-colors duration-200"
                >
                  <div className="relative h-44 md:h-48 overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="inline-flex items-center px-2 py-0.5 bg-accent-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
                        {article.categoryName}
                      </span>
                    </div>
                    {article.verified && (
                      <div className="absolute top-3 right-3">
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-green-600 text-white text-xs rounded-full whitespace-nowrap">
                          <i className="ri-shield-check-line text-[10px]"></i> 已核实
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="p-4">
                    <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-200/70">
                      <span className="text-xs text-foreground-400">{article.date}</span>
                      <span className="text-xs text-foreground-400">{article.views.toLocaleString()} 阅读</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                  最新曝光
                </h2>
                <p className="text-sm text-foreground-500 mt-1">持续追踪，实时更新</p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {latestArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="flex gap-4 p-4 bg-background-100 rounded-lg cursor-pointer group hover:bg-primary-50/50 transition-colors duration-200"
                >
                  <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-md overflow-hidden">
                    <img
                      src={article.thumbUrl}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-[10px] text-accent-600 font-medium whitespace-nowrap">
                        {article.categoryName}
                      </span>
                      <span className="text-[10px] text-foreground-400">{article.date}</span>
                    </div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{article.excerpt}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-accent-600">
          <div className="w-full px-4 md:px-6 text-center max-w-3xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
              您的每一次消费，都值得被认真对待
            </h2>
            <p className="text-sm md:text-base text-white/80 mb-8 leading-relaxed">
              如果您遭遇了消费陷阱，或发现了不为人知的行业黑幕，欢迎向我们投稿爆料。
              每一份真实的声音，都是推动行业进步的力量。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center px-6 py-3 bg-white text-accent-700 font-medium rounded-md hover:bg-white/90 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              立即投稿
              <i className="ri-send-plane-line ml-2"></i>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}